import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    backgroundColor: '#f7f9fc',
    color: '#0b2445',
    padding: '24px'
  },

  content: {
    width: '100%',
    maxWidth: '1600px',
    margin: '0 auto'
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '28px',
    minHeight: '72px',
    marginBottom: '28px',

    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      gap: '12px'
    }
  },

  logo: {
    display: 'block',
    width: '200px',
    maxWidth: '100%',
    height: 'auto',
    objectFit: 'contain',

    [theme.breakpoints.down('sm')]: {
      width: '220px'
    }
  },

  headerText: {
    paddingLeft: '26px',
    borderLeft: '1px solid #d7e0ec',

    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      borderLeft: 0
    }
  },

  systemName: {
    color: '#0b2445',
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: 1.3
  },

  institutionName: {
    color: '#52647c',
    fontSize: '16px',
    lineHeight: 1.5
  },

  infoCard: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    minHeight: '120px',
    padding: '24px 120px 24px 24px',
    marginBottom: '20px',
    overflow: 'hidden',
    background:
      'linear-gradient(105deg, #f8fbff 0%, #eef6ff 100%)',
    border: '1px solid #9ec7f7',
    borderRadius: '8px',

    [theme.breakpoints.down('sm')]: {
      padding: '20px'
    },

    [theme.breakpoints.down('xs')]: {
      gap: '14px'
    }
  },

  infoIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '46px',
    height: '46px',
    marginRight: '20px',
    color: '#ffffff',
    backgroundColor: '#0753a6',
    borderRadius: '50%',

    [theme.breakpoints.down('xs')]: {
      width: '38px',
      height: '38px',
      marginRight: 0
    }
  },

  infoIcon: {
    fontSize: '28px',

    [theme.breakpoints.down('xs')]: {
      fontSize: '23px'
    }
  },

  infoContent: {
    position: 'relative',
    zIndex: 1,
    flex: 1
  },

  infoTitle: {
    marginBottom: '8px',
    color: '#0b2445',
    fontSize: '19px',
    fontWeight: 700
  },

  infoText: {
    maxWidth: '1100px',
    color: '#18375f',
    fontSize: '15px',
    lineHeight: 1.6
  },

  watermark: {
    position: 'absolute',
    top: '14px',
    right: '42px',
    width: '100px',
    height: '100px',
    objectFit: 'contain',
    opacity: 0.1,

    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },

  listCard: {
    marginBottom: '20px',
    overflow: 'hidden',
    backgroundColor: '#ffffff',
    border: '1px solid #d6deea',
    borderRadius: '8px',
    boxShadow: '0 1px 2px rgba(11, 36, 69, 0.03)'
  },

  listCardHeader: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '74px',
    padding: '14px 22px',
    borderBottom: '1px solid #d6deea',

    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
      padding: '14px'
    }
  },

  dateIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '44px',
    height: '44px',
    marginRight: '18px',
    color: '#ffffff',
    backgroundColor: '#0753a6',
    borderRadius: '50%',

    [theme.breakpoints.down('xs')]: {
      width: '38px',
      height: '38px',
      marginRight: '12px'
    }
  },

  dateIcon: {
    fontSize: '23px'
  },

  dateTitle: {
    color: '#0b2445',
    fontSize: '20px',
    fontWeight: 700,
    textTransform: 'lowercase',

    '&::first-letter': {
      textTransform: 'uppercase'
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: '17px'
    }
  },

  recordCountEmpty: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '120px',
    minHeight: '36px',
    padding: '6px 18px',
    marginLeft: '18px',
    color: '#0753a6',
    fontSize: '13px',
    fontWeight: 600,
    backgroundColor: '#edf5ff',
    border: '1px solid #cde2fb',
    borderRadius: '999px',

    [theme.breakpoints.down('xs')]: {
      minWidth: 'auto',
      minHeight: '30px',
      padding: '4px 12px',
      marginLeft: 'auto'
    }
  },

  recordCountActive: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '120px',
    minHeight: '36px',
    padding: '6px 18px',
    marginLeft: '18px',
    color: '#19723b',
    fontSize: '13px',
    fontWeight: 600,
    backgroundColor: '#edf8f0',
    border: '1px solid #cdebd5',
    borderRadius: '999px',

    [theme.breakpoints.down('xs')]: {
      minWidth: 'auto',
      minHeight: '30px',
      padding: '4px 12px',
      marginLeft: 'auto'
    }
  },

  emptyState: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '142px',
    padding: '28px',

    [theme.breakpoints.down('xs')]: {
      justifyContent: 'flex-start',
      minHeight: '120px',
      padding: '22px 16px'
    }
  },

  emptyIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '72px',
    height: '72px',
    marginRight: '24px',
    color: '#0753a6',
    backgroundColor: '#edf5ff',
    borderRadius: '50%',

    [theme.breakpoints.down('xs')]: {
      width: '54px',
      height: '54px',
      marginRight: '16px'
    }
  },

  emptyIcon: {
    fontSize: '32px'
  },

  emptyTitle: {
    color: '#0b2445',
    fontSize: '18px',
    fontWeight: 700,

    [theme.breakpoints.down('xs')]: {
      fontSize: '16px'
    }
  },

  emptyText: {
    marginTop: '3px',
    color: '#53657d',
    fontSize: '14px'
  },

  tableContainer: {
    width: '100%',
    overflowX: 'auto'
  },

  table: {
    minWidth: '960px',
    tableLayout: 'fixed'
  },

  tableHeader: {
    backgroundColor: '#ffffff',

    '& .MuiTableCell-head': {
      height: '58px',
      padding: '14px 24px',
      borderBottom: '1px solid #d6deea'
    }
  },

  columnHeader: {
    alignItems: 'left',
  },

  columnHeaderIcon: {
    flexShrink: 0,
    color: '#415e83',
    fontSize: '20px'
  },

  columnHeaderText: {
    color: '#0b2445',
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: 1.3,
    textTransform: 'uppercase'
  },

  entryColumn: {
    //width: '13%',
    textAlign: 'center',
  },

  nameColumn: {
    //width: '18%',
    textAlign: 'center',
  },

  locationColumn: {
    //width: '26%'
    textAlign: 'center',
  },

  causeColumn: {
    //width: '25%'
    textAlign: 'center',
  },

  cityColumn: {
    //width: '18%'
    textAlign: 'center',
  },

  tableRow: {
    transition: 'background-color 150ms ease',

    '&:nth-of-type(even)': {
      backgroundColor: '#fbfcfe'
    },

    '&:hover': {
      backgroundColor: '#f3f7fc'
    },

    '&:last-child .MuiTableCell-root': {
      borderBottom: 0
    }
  },

  tableCell: {
    height: '54px',
    padding: '12px 24px',
    verticalAlign: 'middle',
    borderBottom: '1px solid #dde4ed',
    textAlign: 'center',
  },

  cellText: {
    color: '#102f55',
    fontSize: '14px',
    lineHeight: 1.45,
    wordBreak: 'break-word',
  },

  cityText: {
    color: '#102f55',
    fontSize: '14px',
    lineHeight: 1.45,
    wordBreak: 'break-word'
  },

  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '280px',
    color: '#0753a6'
  },

  loadingText: {
    marginTop: '16px',
    color: '#52647c',
    fontSize: '15px'
  },

  errorContainer: {
    padding: '44px 24px',
    marginBottom: '20px',
    textAlign: 'center',
    backgroundColor: '#fff8f8',
    border: '1px solid #efc5c5',
    borderRadius: '8px'
  },

  errorTitle: {
    color: '#9b1c1c',
    fontSize: '18px',
    fontWeight: 700
  },

  errorText: {
    marginTop: '6px',
    color: '#704343',
    fontSize: '14px'
  },

  footer: {
    padding: '18px 22px',
    marginTop: '36px',
    backgroundColor: '#ffffff',
    border: '1px solid #d6deea',
    borderRadius: '8px'
  },

  footerItem: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '48px'
  },

  footerIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '44px',
    height: '44px',
    marginRight: '14px'
  },

  footerLogo: {
    display: 'block',
    maxWidth: '42px',
    maxHeight: '42px',
    objectFit: 'contain'
  },

  footerIcon: {
    flexShrink: 0,
    marginRight: '16px',
    color: '#0b376d',
    fontSize: '30px'
  },

  footerTitle: {
    color: '#0b2445',
    fontSize: '14px',
    fontWeight: 700
  },

  footerText: {
    color: '#53657d',
    fontSize: '13px',
    lineHeight: 1.45
  },

  footerDate: {
    color: '#0b2445',
    fontSize: '14px',
    fontWeight: 700
  },

  contactText: {
    color: '#0753a6',
    fontSize: '16px',
    fontWeight: 700
  },

  [theme.breakpoints.down('sm')]: {
    root: {
      padding: '18px'
    }
  },

  [theme.breakpoints.down('xs')]: {
    root: {
      padding: '12px'
    },

    footer: {
      padding: '16px'
    }
  }
}))

export default useStyles